import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AddOrUpdateStaffInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  phonetic: Scalars['String']['input'];
  productionId?: InputMaybe<Scalars['Int']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminActivity = {
  __typename?: 'AdminActivity';
  createdAt: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  productionId: Scalars['Int']['output'];
  stageId: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  userLineId: Scalars['String']['output'];
};

export type AdminUser = {
  __typename?: 'AdminUser';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type AssignSeatInputGuest = {
  id: Scalars['Int']['input'];
  seatId: Scalars['Int']['input'];
};

export type AssignSeatInputSeat = {
  id: Scalars['Int']['input'];
  reservationId: Scalars['Int']['input'];
};

export type AssignSeatsInput = {
  guests: Array<InputMaybe<AssignSeatInputGuest>>;
  seats: Array<InputMaybe<AssignSeatInputSeat>>;
};

export type CancelManagementItems = {
  __typename?: 'CancelManagementItems';
  guestTypes: Array<Maybe<GuestType>>;
  guests: Array<Maybe<Guest>>;
  payments: Array<Maybe<Payment>>;
  prices: Array<Maybe<Price>>;
  reservations: Array<Maybe<Reservation>>;
  seatTypes: Array<Maybe<SeatType>>;
  seats: Array<Maybe<Seat>>;
};

export type CancelledReservationsData = {
  __typename?: 'CancelledReservationsData';
  guestTypes: Array<Maybe<GuestType>>;
  guests: Array<Maybe<Guest>>;
  payments: Array<Maybe<Payment>>;
  prices: Array<Maybe<Price>>;
  productions: Array<Maybe<Production>>;
  reservations: Array<Maybe<Reservation>>;
  seatTypes: Array<Maybe<SeatType>>;
  seats: Array<Maybe<Seat>>;
  stages: Array<Maybe<Stage>>;
};

export type CheckAuthTokenInput = {
  stageId: Scalars['Int']['input'];
  token: Scalars['String']['input'];
};

export type CheckConfirmTokenInput = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ConfirmManagementItems = {
  __typename?: 'ConfirmManagementItems';
  guestTypes: Array<Maybe<GuestType>>;
  guests: Array<Maybe<Guest>>;
  payments: Array<Maybe<Payment>>;
  prices: Array<Maybe<Price>>;
  reservations: Array<Maybe<Reservation>>;
  seatTypes: Array<Maybe<SeatType>>;
  seats: Array<Maybe<Seat>>;
};

export type ConfirmReservationInput = {
  confirm: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};

export type CopySeatsInput = {
  stageId1: Scalars['Int']['input'];
  stageId2: Scalars['Int']['input'];
};

export type CreateGuestInput = {
  column: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  row: Scalars['Int']['input'];
  type: Scalars['Int']['input'];
};

export type CreateGuestTypeInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  stageId: Scalars['Int']['input'];
};

export type CreateMasterUserInput = {
  email: Scalars['String']['input'];
  master?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateOwnerInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateProductionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Int']['input'];
  location: Scalars['String']['input'];
  location_description: Scalars['String']['input'];
  location_url: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['Int']['input'];
  theaterCompanyId: Scalars['Int']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReservationInput = {
  email: Scalars['String']['input'];
  finalPrice: Scalars['Int']['input'];
  groupSize: Scalars['Int']['input'];
  invitationId?: InputMaybe<Scalars['Int']['input']>;
  lineId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<Scalars['Int']['input']>;
  phonetic: Scalars['String']['input'];
  specialGroupSizes: Array<InputMaybe<Scalars['Int']['input']>>;
  stageId: Scalars['Int']['input'];
  usePoint: Scalars['Int']['input'];
};

export type CreateSeatTypeInput = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  stageId: Scalars['Int']['input'];
};

export type CreateSeatsFromCsvInput = {
  object: Scalars['String']['input'];
  stageId: Scalars['Int']['input'];
};

export type CreateSeatsInput = {
  column: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  row: Scalars['Int']['input'];
  seatName: Scalars['String']['input'];
  stageId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['Int']['input'];
};

export type CreateStageInput = {
  caution: Scalars['String']['input'];
  disableSeatSelect: Scalars['Boolean']['input'];
  endDateTime: Scalars['Int']['input'];
  mailMessage?: InputMaybe<Scalars['String']['input']>;
  openDateTime: Scalars['Int']['input'];
  productionId: Scalars['Int']['input'];
  reservationLimit: Scalars['Int']['input'];
  reservationStart: Scalars['Int']['input'];
  stageName: Scalars['String']['input'];
  startDateTime: Scalars['Int']['input'];
};

export type CreateTheaterCompanyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ownerEmails: Array<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVipReservationInput = {
  authToken: Scalars['String']['input'];
  reservationId?: InputMaybe<Scalars['Int']['input']>;
  seat: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type CustomEMailInput = {
  subject: Scalars['String']['input'];
  target: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export type GetAllPricesInput = {
  stageIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type GetPaymentsInput = {
  productionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type GetReservationWithoutSeatInput = {
  lineId: Scalars['String']['input'];
  stageId: Scalars['Int']['input'];
};

export type Guest = {
  __typename?: 'Guest';
  guestType: Scalars['Int']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  reservationId: Scalars['Int']['output'];
  seatId: Scalars['Int']['output'];
  selfReserved?: Maybe<Scalars['Boolean']['output']>;
};

export type GuestType = {
  __typename?: 'GuestType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  stageId: Scalars['Int']['output'];
};

export type MasterInitialItems = {
  __typename?: 'MasterInitialItems';
  productions: Array<Maybe<Production>>;
  stages: Array<Maybe<Stage>>;
  theaterCompanies: Array<Maybe<TheaterCompany>>;
};

export type MasterUser = {
  __typename?: 'MasterUser';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  master: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  assignSeats: Scalars['Boolean']['output'];
  confirmReservation: Response;
  copySeats: Scalars['Int']['output'];
  createAuthToken?: Maybe<Scalars['String']['output']>;
  createGuestType?: Maybe<GuestType>;
  createMasterUser: MasterUser;
  createProduction: Response;
  createReservation?: Maybe<Reservation>;
  createSeatType?: Maybe<SeatType>;
  createSeats: Scalars['Int']['output'];
  createSeatsFromCsv: Response;
  createStage?: Maybe<Stage>;
  createTheaterCompany: Response;
  createVipReservation: Response;
  deleteGuestType?: Maybe<GuestType>;
  deleteSeatType?: Maybe<SeatType>;
  getOrRegisterUser?: Maybe<OneAheadUser>;
  sendConfirmEmail: Response;
  sendEmailToStageGuests: Response;
  setPriceList?: Maybe<Scalars['Boolean']['output']>;
  setStaffsOfProduction?: Maybe<Scalars['Boolean']['output']>;
  setStaffsOfStage?: Maybe<Scalars['Boolean']['output']>;
  submitReservation: Response;
  tempReservation: Response;
  updatePayment: Response;
  updatePayments: Response;
  updateProduction: Response;
  updateReservation: Response;
  updateSeats: Response;
  updateStage: Scalars['Boolean']['output'];
  updateTheaterCompany: Response;
};


export type MutationAssignSeatsArgs = {
  input: AssignSeatsInput;
};


export type MutationConfirmReservationArgs = {
  input: ConfirmReservationInput;
};


export type MutationCopySeatsArgs = {
  input: CopySeatsInput;
};


export type MutationCreateAuthTokenArgs = {
  stageId: Scalars['Int']['input'];
};


export type MutationCreateGuestTypeArgs = {
  input: CreateGuestTypeInput;
};


export type MutationCreateMasterUserArgs = {
  input: CreateMasterUserInput;
};


export type MutationCreateProductionArgs = {
  input: CreateProductionInput;
};


export type MutationCreateReservationArgs = {
  input: CreateReservationInput;
};


export type MutationCreateSeatTypeArgs = {
  input: CreateSeatTypeInput;
};


export type MutationCreateSeatsArgs = {
  input: Array<Array<CreateSeatsInput>>;
};


export type MutationCreateSeatsFromCsvArgs = {
  input: CreateSeatsFromCsvInput;
};


export type MutationCreateStageArgs = {
  input: CreateStageInput;
};


export type MutationCreateTheaterCompanyArgs = {
  input: CreateTheaterCompanyInput;
};


export type MutationCreateVipReservationArgs = {
  input: CreateVipReservationInput;
};


export type MutationDeleteGuestTypeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteSeatTypeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationGetOrRegisterUserArgs = {
  input: GetOrRegisterUserInput;
};


export type MutationSendConfirmEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationSendEmailToStageGuestsArgs = {
  input: SendEmailToStageGuestsInput;
};


export type MutationSetPriceListArgs = {
  input: SetPriceListInput;
};


export type MutationSetStaffsOfProductionArgs = {
  input: SetStaffsInput;
};


export type MutationSetStaffsOfStageArgs = {
  input: SetStaffsInput;
};


export type MutationSubmitReservationArgs = {
  input: SubmitReservationInput;
};


export type MutationTempReservationArgs = {
  input: TempReservationInput;
};


export type MutationUpdatePaymentArgs = {
  input: UpdatedPaymentInput;
};


export type MutationUpdatePaymentsArgs = {
  input: UpdatePaymentsInput;
};


export type MutationUpdateProductionArgs = {
  input: UpdateProductionInput;
};


export type MutationUpdateReservationArgs = {
  input: UpdateReservationInput;
};


export type MutationUpdateSeatsArgs = {
  input: UpdateSeatsInput2;
};


export type MutationUpdateStageArgs = {
  input: UpdateStageInput;
};


export type MutationUpdateTheaterCompanyArgs = {
  input: UpdateTheaterCompanyInput;
};

export type OneAheadUser = {
  __typename?: 'OneAheadUser';
  admin?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  line_id?: Maybe<Scalars['String']['output']>;
  line_name?: Maybe<Scalars['String']['output']>;
  line_picture?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['Boolean']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  description: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  productionId: Scalars['Int']['output'];
};

export type Price = {
  __typename?: 'Price';
  guestType: Scalars['Int']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Int']['output'];
  seatType: Scalars['Int']['output'];
  stageId: Scalars['Int']['output'];
};

export type Production = {
  __typename?: 'Production';
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  location: Scalars['String']['output'];
  locationLink?: Maybe<Scalars['String']['output']>;
  location_description: Scalars['String']['output'];
  location_url: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['Int']['output'];
  theaterCompanyId?: Maybe<Scalars['Int']['output']>;
  theaterCompanyName?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  checkAuthToken: Scalars['Boolean']['output'];
  checkConfirmToken: Response;
  createSpreadSheet: Response;
  getAllPayments: Array<Maybe<Payment>>;
  getAllPrices: Array<Maybe<Price>>;
  getAllProductions?: Maybe<Array<Maybe<Production>>>;
  getAllSeatsOfStage: Array<Maybe<Seat>>;
  getAllStages: Array<Maybe<Stage>>;
  getCancelManagementItems: CancelManagementItems;
  getCancelledReservations: CancelledReservationsData;
  getConfirmManagementItems: ConfirmManagementItems;
  getGuestTypes: Array<Maybe<GuestType>>;
  getGuestsOfStage: Array<Maybe<Guest>>;
  getLINEProfile2?: Maybe<User>;
  getMasterInitialItems: MasterInitialItems;
  getMasterUser?: Maybe<MasterUser>;
  getOneAheadProductionInfo?: Maybe<Production>;
  getOneAheadProductionsInfo: Array<Maybe<Production>>;
  getOneAheadUserInfo?: Maybe<User>;
  getOwnTheaterCompanies: Array<Maybe<TheaterCompany>>;
  getPaymentsOfProduction: Array<Maybe<Payment>>;
  getPriceList: Array<Maybe<Price>>;
  getRemainingSeats: Scalars['Int']['output'];
  getReservationByLineId?: Maybe<ReservationData>;
  getReservationInitialData: ReservationInitialData;
  getReservationWithoutSeat?: Maybe<Reservation>;
  getReservationsByEmail: ReservationDataForUpdate;
  getReservationsOfStage: Array<Maybe<Reservation>>;
  getSeatTypes: Array<Maybe<SeatType>>;
  getSeatsOfStage: Array<Array<Maybe<Seat>>>;
  getSeatsSettingsOfStage: SeatSettings;
  getStaffsOfProduction: Array<Maybe<Staff>>;
  getStaffsOfStage: Array<Maybe<Staff>>;
};


export type QueryCheckAuthTokenArgs = {
  input: CheckAuthTokenInput;
};


export type QueryCheckConfirmTokenArgs = {
  input: CheckConfirmTokenInput;
};


export type QueryCreateSpreadSheetArgs = {
  stageId: Scalars['Int']['input'];
};


export type QueryGetAllPaymentsArgs = {
  input: GetPaymentsInput;
};


export type QueryGetAllPricesArgs = {
  input: GetAllPricesInput;
};


export type QueryGetAllProductionsArgs = {
  input?: InputMaybe<GetAllInput>;
};


export type QueryGetAllSeatsOfStageArgs = {
  stageId: Scalars['Int']['input'];
};


export type QueryGetAllStagesArgs = {
  productionId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCancelManagementItemsArgs = {
  stageId: Scalars['Int']['input'];
};


export type QueryGetCancelledReservationsArgs = {
  stageIds: Array<Scalars['Int']['input']>;
};


export type QueryGetConfirmManagementItemsArgs = {
  stageId: Scalars['Int']['input'];
};


export type QueryGetGuestTypesArgs = {
  stageId: Scalars['Int']['input'];
};


export type QueryGetGuestsOfStageArgs = {
  stageId: Scalars['Int']['input'];
};


export type QueryGetLineProfile2Args = {
  input: GetLineProfileInput;
};


export type QueryGetMasterInitialItemsArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryGetMasterUserArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetOneAheadProductionInfoArgs = {
  productionId: Scalars['Int']['input'];
};


export type QueryGetOneAheadProductionsInfoArgs = {
  lineId: Scalars['String']['input'];
};


export type QueryGetOneAheadUserInfoArgs = {
  idToken: Scalars['String']['input'];
};


export type QueryGetOwnTheaterCompaniesArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetPaymentsOfProductionArgs = {
  productionId: Scalars['Int']['input'];
};


export type QueryGetPriceListArgs = {
  stageId: Scalars['Int']['input'];
};


export type QueryGetRemainingSeatsArgs = {
  stageId: Scalars['Int']['input'];
};


export type QueryGetReservationByLineIdArgs = {
  lineId: Scalars['String']['input'];
};


export type QueryGetReservationInitialDataArgs = {
  stageId: Scalars['Int']['input'];
};


export type QueryGetReservationWithoutSeatArgs = {
  input: GetReservationWithoutSeatInput;
};


export type QueryGetReservationsByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetReservationsOfStageArgs = {
  stageId: Scalars['Int']['input'];
};


export type QueryGetSeatTypesArgs = {
  stageId: Scalars['Int']['input'];
};


export type QueryGetSeatsOfStageArgs = {
  stageId: Scalars['Int']['input'];
};


export type QueryGetSeatsSettingsOfStageArgs = {
  stageId: Scalars['Int']['input'];
};


export type QueryGetStaffsOfProductionArgs = {
  productionId: Scalars['Int']['input'];
};


export type QueryGetStaffsOfStageArgs = {
  stageId: Scalars['Int']['input'];
};

export type Reservation = {
  __typename?: 'Reservation';
  cancellationTime?: Maybe<Scalars['Int']['output']>;
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  confirmationTime?: Maybe<Scalars['Int']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  invitationId?: Maybe<Scalars['Int']['output']>;
  lineId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<Scalars['Int']['output']>;
  paymentDeadline?: Maybe<Scalars['Int']['output']>;
  paymentTime?: Maybe<Scalars['Int']['output']>;
  phonetic: Scalars['String']['output'];
  stageId: Scalars['Int']['output'];
  usePoint: Scalars['Int']['output'];
};

export type ReservationData = {
  __typename?: 'ReservationData';
  guestTypes: Array<Maybe<GuestType>>;
  guests: Array<Maybe<Guest>>;
  payments: Array<Maybe<Payment>>;
  prices: Array<Maybe<Price>>;
  productions: Array<Maybe<Production>>;
  reservations: Array<Maybe<Reservation>>;
  seatTypes: Array<Maybe<SeatType>>;
  seats: Array<Maybe<Seat>>;
  staffs: Array<Maybe<Staff>>;
  stages: Array<Maybe<Stage>>;
};

export type ReservationDataForUpdate = {
  __typename?: 'ReservationDataForUpdate';
  guestTypes: Array<Maybe<GuestType>>;
  guests: Array<Maybe<Guest>>;
  payments: Array<Maybe<Payment>>;
  prices: Array<Maybe<Price>>;
  productions: Array<Maybe<Production>>;
  reservations: Array<Maybe<Reservation>>;
  seatTypes: Array<Maybe<SeatType>>;
  seats: Array<Maybe<Seat>>;
  staffs: Array<Maybe<Staff>>;
  stages: Array<Maybe<Stage>>;
};

export type ReservationInitialData = {
  __typename?: 'ReservationInitialData';
  guestTypes: Array<Maybe<GuestType>>;
  payments: Array<Maybe<Payment>>;
  prices: Array<Maybe<Price>>;
  productionName?: Maybe<Scalars['String']['output']>;
  remainingSeats: Scalars['Int']['output'];
  seatTypes: Array<Maybe<SeatType>>;
  seats: Array<Maybe<Seat>>;
  staffs: Array<Maybe<Staff>>;
  stage?: Maybe<Stage>;
};

export type ReservedGuestsInput = {
  guestType: Scalars['Int']['input'];
  seatId: Scalars['Int']['input'];
  seatType: Scalars['Int']['input'];
};

export type Response = {
  __typename?: 'Response';
  message?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type Seat = {
  __typename?: 'Seat';
  column: Scalars['Int']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  pairGuestId?: Maybe<Scalars['Int']['output']>;
  reservationId?: Maybe<Scalars['Int']['output']>;
  row: Scalars['Int']['output'];
  seatName: Scalars['String']['output'];
  stageId: Scalars['Int']['output'];
  state?: Maybe<Scalars['Int']['output']>;
  tempLineId?: Maybe<Scalars['String']['output']>;
  tempMail?: Maybe<Scalars['String']['output']>;
  type: Scalars['Int']['output'];
};

export type SeatSettings = {
  __typename?: 'SeatSettings';
  guestTypes: Array<Maybe<GuestType>>;
  guests: Array<Maybe<Guest>>;
  prices: Array<Maybe<Price>>;
  reservations: Array<Maybe<Reservation>>;
  seatTypes: Array<Maybe<SeatType>>;
  seats: Array<Maybe<Seat>>;
  staffs: Array<Maybe<Staff>>;
};

export type SeatType = {
  __typename?: 'SeatType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  stageId: Scalars['Int']['output'];
};

export type SendEmailToStageGuestsInput = {
  customEmailInput?: InputMaybe<CustomEMailInput>;
  stageId: Scalars['Int']['input'];
  type: Scalars['Int']['input'];
};

export type SetPriceInput = {
  guestType: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Int']['input'];
  seatType: Scalars['Int']['input'];
  stageId: Scalars['Int']['input'];
};

export type SetPriceListInput = {
  priceList: Array<InputMaybe<SetPriceInput>>;
};

export type SetStaffsInput = {
  addOrUpdateStaffsInput: Array<InputMaybe<AddOrUpdateStaffInput>>;
  deleteStaffsInput: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type Staff = {
  __typename?: 'Staff';
  id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  phonetic: Scalars['String']['output'];
  productionId: Scalars['Int']['output'];
  stageId?: Maybe<Scalars['Int']['output']>;
};

export type Stage = {
  __typename?: 'Stage';
  capacity: Scalars['Int']['output'];
  caution: Scalars['String']['output'];
  disableSeatSelect?: Maybe<Scalars['Boolean']['output']>;
  endDateTime: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  mailMessage?: Maybe<Scalars['String']['output']>;
  openDateTime: Scalars['Int']['output'];
  productionId: Scalars['Int']['output'];
  reservationLimit: Scalars['Int']['output'];
  reservationStart: Scalars['Int']['output'];
  stageName: Scalars['String']['output'];
  startDateTime: Scalars['Int']['output'];
};

export type SubmitReservationInput = {
  authToken?: InputMaybe<Scalars['String']['input']>;
  guests?: InputMaybe<Array<ReservedGuestsInput>>;
  reservationData: CreateReservationInput;
  seats?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TempReservationInput = {
  lineId: Scalars['String']['input'];
  mail: Scalars['String']['input'];
  stageId: Scalars['Int']['input'];
  updateSeatsInput: Array<InputMaybe<UpdateSeatsInput>>;
};

export type TheaterCompany = {
  __typename?: 'TheaterCompany';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type UpdatePaymentsInput = {
  payments: Array<InputMaybe<UpdatedPayments>>;
  productionId: Scalars['Int']['input'];
};

export type UpdateProductionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  location: Scalars['String']['input'];
  location_description: Scalars['String']['input'];
  location_url: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['Int']['input'];
  theaterCompanyId: Scalars['Int']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReservationDataInput = {
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  invitationId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<Scalars['Int']['input']>;
  phonetic?: InputMaybe<Scalars['String']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
  usePoint?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateReservationInput = {
  guests?: InputMaybe<Array<InputMaybe<UpdateGuestsInput>>>;
  reservation: UpdateReservationDataInput;
};

export type UpdateSeatInput = {
  column: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  pairGuestId?: InputMaybe<Scalars['Int']['input']>;
  reservationId?: InputMaybe<Scalars['Int']['input']>;
  row: Scalars['Int']['input'];
  seatName: Scalars['String']['input'];
  stageId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['Int']['input']>;
  tempLineId?: InputMaybe<Scalars['String']['input']>;
  tempMail?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['Int']['input'];
};

export type UpdateSeatsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  lineId?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['Int']['input'];
};

export type UpdateSeatsInput2 = {
  seats: Array<UpdateSeatInput>;
  stageId: Scalars['Int']['input'];
};

export type UpdateStageInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  caution?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  disableSeatSelect?: InputMaybe<Scalars['Boolean']['input']>;
  endDateTime?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  mailMessage?: InputMaybe<Scalars['String']['input']>;
  openDateTime?: InputMaybe<Scalars['Int']['input']>;
  productionId?: InputMaybe<Scalars['Int']['input']>;
  reservationLimit?: InputMaybe<Scalars['Int']['input']>;
  reservationStart?: InputMaybe<Scalars['Int']['input']>;
  stageName?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTheaterCompanyInput = {
  deletedOwnerEmails: Array<InputMaybe<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  ownerEmails: Array<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatedPaymentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdatedPayments = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  productionId: Scalars['Int']['input'];
};

export type User = {
  __typename?: 'User';
  admin: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  lineId: Scalars['String']['output'];
  lineName: Scalars['String']['output'];
  owner: Scalars['Boolean']['output'];
  point: Scalars['Int']['output'];
  profilePictureUrl: Scalars['String']['output'];
};

export type GetAllInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  object_id?: InputMaybe<Scalars['Int']['input']>;
};

export type GetLineProfileInput = {
  clientId: Scalars['String']['input'];
  idToken: Scalars['String']['input'];
};

export type GetOrRegisterUserInput = {
  clientId: Scalars['String']['input'];
  idToken: Scalars['String']['input'];
};

export type UpdateGuestsInput = {
  guestType: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  reservationId: Scalars['Int']['input'];
  seatId: Scalars['Int']['input'];
};

export type CreateSeatsMutationVariables = Exact<{
  input: Array<Array<CreateSeatsInput> | CreateSeatsInput> | Array<CreateSeatsInput> | CreateSeatsInput;
}>;


export type CreateSeatsMutation = { __typename?: 'Mutation', createSeats: number };

export type CopySeatsMutationVariables = Exact<{
  input: CopySeatsInput;
}>;


export type CopySeatsMutation = { __typename?: 'Mutation', copySeats: number };

export type CreateStageMutationVariables = Exact<{
  input: CreateStageInput;
}>;


export type CreateStageMutation = { __typename?: 'Mutation', createStage?: { __typename?: 'Stage', id: number, productionId: number, stageName: string, openDateTime: number, startDateTime: number, endDateTime: number, reservationStart: number, reservationLimit: number, caution: string, mailMessage?: string | null, disableSeatSelect?: boolean | null } | null };

export type CreateSeatTypeMutationVariables = Exact<{
  input: CreateSeatTypeInput;
}>;


export type CreateSeatTypeMutation = { __typename?: 'Mutation', createSeatType?: { __typename?: 'SeatType', id: number, stageId: number, name: string, description: string } | null };

export type DeleteSeatTypeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteSeatTypeMutation = { __typename?: 'Mutation', deleteSeatType?: { __typename?: 'SeatType', id: number, stageId: number, name: string, description: string } | null };

export type CreateGuestTypeMutationVariables = Exact<{
  input: CreateGuestTypeInput;
}>;


export type CreateGuestTypeMutation = { __typename?: 'Mutation', createGuestType?: { __typename?: 'GuestType', id: number, stageId: number, name: string } | null };

export type DeleteGuestTypeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteGuestTypeMutation = { __typename?: 'Mutation', deleteGuestType?: { __typename?: 'GuestType', id: number, stageId: number, name: string } | null };

export type CreateReservationMutationVariables = Exact<{
  input: CreateReservationInput;
}>;


export type CreateReservationMutation = { __typename?: 'Mutation', createReservation?: { __typename?: 'Reservation', id?: number | null, lineId?: string | null, name: string, phonetic: string, email: string, note?: string | null, stageId: number, usePoint: number, invitationId?: number | null } | null };

export type SetPriceListMutationVariables = Exact<{
  input: SetPriceListInput;
}>;


export type SetPriceListMutation = { __typename?: 'Mutation', setPriceList?: boolean | null };

export type SetStaffsOfProductionMutationVariables = Exact<{
  input: SetStaffsInput;
}>;


export type SetStaffsOfProductionMutation = { __typename?: 'Mutation', setStaffsOfProduction?: boolean | null };

export type SetStaffsOfStageMutationVariables = Exact<{
  input: SetStaffsInput;
}>;


export type SetStaffsOfStageMutation = { __typename?: 'Mutation', setStaffsOfStage?: boolean | null };

export type SubmitReservationMutationVariables = Exact<{
  input: SubmitReservationInput;
}>;


export type SubmitReservationMutation = { __typename?: 'Mutation', submitReservation: { __typename?: 'Response', ok: boolean, message?: string | null } };

export type UpdateStageMutationVariables = Exact<{
  input: UpdateStageInput;
}>;


export type UpdateStageMutation = { __typename?: 'Mutation', updateStage: boolean };

export type CreateAuthTokenMutationVariables = Exact<{
  stageId: Scalars['Int']['input'];
}>;


export type CreateAuthTokenMutation = { __typename?: 'Mutation', createAuthToken?: string | null };

export type AssignSeatsMutationVariables = Exact<{
  input: AssignSeatsInput;
}>;


export type AssignSeatsMutation = { __typename?: 'Mutation', assignSeats: boolean };

export type UpdateReservationMutationVariables = Exact<{
  input: UpdateReservationInput;
}>;


export type UpdateReservationMutation = { __typename?: 'Mutation', updateReservation: { __typename?: 'Response', ok: boolean, message?: string | null } };

export type TempReservationMutationVariables = Exact<{
  input: TempReservationInput;
}>;


export type TempReservationMutation = { __typename?: 'Mutation', tempReservation: { __typename?: 'Response', ok: boolean, message?: string | null } };

export type UpdatePaymentsMutationVariables = Exact<{
  input: UpdatePaymentsInput;
}>;


export type UpdatePaymentsMutation = { __typename?: 'Mutation', updatePayments: { __typename?: 'Response', ok: boolean, message?: string | null } };

export type GetOrRegisterUserMutationVariables = Exact<{
  input: GetOrRegisterUserInput;
}>;


export type GetOrRegisterUserMutation = { __typename?: 'Mutation', getOrRegisterUser?: { __typename?: 'OneAheadUser', id?: number | null, idToken?: string | null, line_id?: string | null, line_name?: string | null, line_picture?: string | null, admin?: boolean | null, owner?: boolean | null, deleted?: boolean | null } | null };

export type CreateVipReservationMutationVariables = Exact<{
  input: CreateVipReservationInput;
}>;


export type CreateVipReservationMutation = { __typename?: 'Mutation', createVipReservation: { __typename?: 'Response', ok: boolean, message?: string | null, object?: string | null } };

export type SendEmailToStageGuestsMutationVariables = Exact<{
  input: SendEmailToStageGuestsInput;
}>;


export type SendEmailToStageGuestsMutation = { __typename?: 'Mutation', sendEmailToStageGuests: { __typename?: 'Response', ok: boolean, message?: string | null, object?: string | null } };

export type CreateTheaterCompanyMutationVariables = Exact<{
  input: CreateTheaterCompanyInput;
}>;


export type CreateTheaterCompanyMutation = { __typename?: 'Mutation', createTheaterCompany: { __typename?: 'Response', ok: boolean, message?: string | null, object?: string | null } };

export type UpdateProductionMutationVariables = Exact<{
  input: UpdateProductionInput;
}>;


export type UpdateProductionMutation = { __typename?: 'Mutation', updateProduction: { __typename?: 'Response', ok: boolean, message?: string | null, object?: string | null } };

export type UpdatePaymentMutationVariables = Exact<{
  input: UpdatedPaymentInput;
}>;


export type UpdatePaymentMutation = { __typename?: 'Mutation', updatePayment: { __typename?: 'Response', ok: boolean, message?: string | null } };

export type UpdateTheaterCompanyMutationVariables = Exact<{
  input: UpdateTheaterCompanyInput;
}>;


export type UpdateTheaterCompanyMutation = { __typename?: 'Mutation', updateTheaterCompany: { __typename?: 'Response', ok: boolean, message?: string | null, object?: string | null } };

export type CreateProductionMutationVariables = Exact<{
  input: CreateProductionInput;
}>;


export type CreateProductionMutation = { __typename?: 'Mutation', createProduction: { __typename?: 'Response', ok: boolean, message?: string | null, object?: string | null } };

export type CreateMasterUserMutationVariables = Exact<{
  input: CreateMasterUserInput;
}>;


export type CreateMasterUserMutation = { __typename?: 'Mutation', createMasterUser: { __typename?: 'MasterUser', id: number, name: string, email: string, master: boolean } };

export type UpdateSeatsMutationVariables = Exact<{
  input: UpdateSeatsInput2;
}>;


export type UpdateSeatsMutation = { __typename?: 'Mutation', updateSeats: { __typename?: 'Response', ok: boolean, message?: string | null, object?: string | null } };

export type ConfirmReservationMutationVariables = Exact<{
  input: ConfirmReservationInput;
}>;


export type ConfirmReservationMutation = { __typename?: 'Mutation', confirmReservation: { __typename?: 'Response', ok: boolean, message?: string | null, object?: string | null } };

export type CreateSeatsFromCsvMutationVariables = Exact<{
  input: CreateSeatsFromCsvInput;
}>;


export type CreateSeatsFromCsvMutation = { __typename?: 'Mutation', createSeatsFromCsv: { __typename?: 'Response', ok: boolean, message?: string | null } };

export type SendConfirmEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendConfirmEmailMutation = { __typename?: 'Mutation', sendConfirmEmail: { __typename?: 'Response', ok: boolean } };

export type GetAllStagesQueryVariables = Exact<{
  productionId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllStagesQuery = { __typename?: 'Query', getAllStages: Array<{ __typename?: 'Stage', id: number, productionId: number, stageName: string, openDateTime: number, startDateTime: number, endDateTime: number, reservationStart: number, reservationLimit: number, caution: string, mailMessage?: string | null, disableSeatSelect?: boolean | null } | null> };

export type GetSeatsOfStageQueryVariables = Exact<{
  stageId: Scalars['Int']['input'];
}>;


export type GetSeatsOfStageQuery = { __typename?: 'Query', getSeatsOfStage: Array<Array<{ __typename?: 'Seat', id?: number | null, stageId: number, seatName: string, row: number, column: number, type: number, state?: number | null, tempLineId?: string | null, tempMail?: string | null } | null>> };

export type GetOneAheadUserInfoQueryVariables = Exact<{
  idToken: Scalars['String']['input'];
}>;


export type GetOneAheadUserInfoQuery = { __typename?: 'Query', getOneAheadUserInfo?: { __typename?: 'User', lineId: string, lineName: string, profilePictureUrl: string, admin: boolean, owner: boolean, point: number } | null };

export type GetOneAheadProductionsInfoQueryVariables = Exact<{
  lineId: Scalars['String']['input'];
}>;


export type GetOneAheadProductionsInfoQuery = { __typename?: 'Query', getOneAheadProductionsInfo: Array<{ __typename?: 'Production', id: number, name: string, description?: string | null, startDate: number, endDate: number, url: string, location: string, locationLink?: string | null, theaterCompanyName?: string | null } | null> };

export type GetOneAheadProductionInfoQueryVariables = Exact<{
  productionId: Scalars['Int']['input'];
}>;


export type GetOneAheadProductionInfoQuery = { __typename?: 'Query', getOneAheadProductionInfo?: { __typename?: 'Production', id: number, name: string, description?: string | null, startDate: number, endDate: number, url: string, location: string, locationLink?: string | null, theaterCompanyName?: string | null } | null };

export type GetSeatTypesQueryVariables = Exact<{
  stageId: Scalars['Int']['input'];
}>;


export type GetSeatTypesQuery = { __typename?: 'Query', getSeatTypes: Array<{ __typename?: 'SeatType', id: number, stageId: number, name: string, description: string } | null> };

export type GetGuestTypesQueryVariables = Exact<{
  stageId: Scalars['Int']['input'];
}>;


export type GetGuestTypesQuery = { __typename?: 'Query', getGuestTypes: Array<{ __typename?: 'GuestType', id: number, name: string, stageId: number } | null> };

export type GetStaffsOfProductionQueryVariables = Exact<{
  productionId: Scalars['Int']['input'];
}>;


export type GetStaffsOfProductionQuery = { __typename?: 'Query', getStaffsOfProduction: Array<{ __typename?: 'Staff', id?: number | null, name: string, phonetic: string, stageId?: number | null, productionId: number } | null> };

export type GetStaffsOfStageQueryVariables = Exact<{
  stageId: Scalars['Int']['input'];
}>;


export type GetStaffsOfStageQuery = { __typename?: 'Query', getStaffsOfStage: Array<{ __typename?: 'Staff', id?: number | null, name: string, phonetic: string, stageId?: number | null, productionId: number } | null> };

export type GetPriceListQueryVariables = Exact<{
  stageId: Scalars['Int']['input'];
}>;


export type GetPriceListQuery = { __typename?: 'Query', getPriceList: Array<{ __typename?: 'Price', id?: number | null, stageId: number, seatType: number, guestType: number, price: number } | null> };

export type GetGuestsOfStageQueryVariables = Exact<{
  stageId: Scalars['Int']['input'];
}>;


export type GetGuestsOfStageQuery = { __typename?: 'Query', getGuestsOfStage: Array<{ __typename?: 'Guest', id?: number | null, reservationId: number, seatId: number, guestType: number, selfReserved?: boolean | null } | null> };

export type GetReservationsOfStageQueryVariables = Exact<{
  stageId: Scalars['Int']['input'];
}>;


export type GetReservationsOfStageQuery = { __typename?: 'Query', getReservationsOfStage: Array<{ __typename?: 'Reservation', id?: number | null, lineId?: string | null, name: string, phonetic: string, email: string, note?: string | null, stageId: number, usePoint: number, invitationId?: number | null, confirmed?: boolean | null, payment?: number | null, paymentDeadline?: number | null, cancelled?: boolean | null, confirmationTime?: number | null, paymentTime?: number | null, cancellationTime?: number | null } | null> };

export type GetRemainingSeatsQueryVariables = Exact<{
  stageId: Scalars['Int']['input'];
}>;


export type GetRemainingSeatsQuery = { __typename?: 'Query', getRemainingSeats: number };

export type GetReservationByLineIdQueryVariables = Exact<{
  lineId: Scalars['String']['input'];
}>;


export type GetReservationByLineIdQuery = { __typename?: 'Query', getReservationByLineId?: { __typename?: 'ReservationData', stages: Array<{ __typename?: 'Stage', id: number, productionId: number, stageName: string, openDateTime: number, startDateTime: number, endDateTime: number, reservationStart: number, reservationLimit: number, caution: string, disableSeatSelect?: boolean | null, capacity: number } | null>, reservations: Array<{ __typename?: 'Reservation', id?: number | null, lineId?: string | null, name: string, phonetic: string, email: string, note?: string | null, stageId: number, usePoint: number, invitationId?: number | null, payment?: number | null } | null>, guests: Array<{ __typename?: 'Guest', id?: number | null, reservationId: number, seatId: number, guestType: number } | null>, staffs: Array<{ __typename?: 'Staff', id?: number | null, name: string, phonetic: string, productionId: number, stageId?: number | null } | null>, seats: Array<{ __typename?: 'Seat', id?: number | null, stageId: number, seatName: string, row: number, column: number, type: number, reservationId?: number | null, state?: number | null, pairGuestId?: number | null } | null>, seatTypes: Array<{ __typename?: 'SeatType', id: number, stageId: number, name: string, description: string } | null>, guestTypes: Array<{ __typename?: 'GuestType', id: number, stageId: number, name: string } | null>, productions: Array<{ __typename?: 'Production', id: number, name: string, description?: string | null, startDate: number, endDate: number, url: string, location: string, locationLink?: string | null, theaterCompanyName?: string | null, theaterCompanyId?: number | null, deleted?: boolean | null } | null>, payments: Array<{ __typename?: 'Payment', id?: number | null, name: string, link?: string | null, productionId: number, description: string } | null>, prices: Array<{ __typename?: 'Price', id?: number | null, stageId: number, seatType: number, guestType: number, price: number } | null> } | null };

export type GetPaymentsOfProductionQueryVariables = Exact<{
  productionId: Scalars['Int']['input'];
}>;


export type GetPaymentsOfProductionQuery = { __typename?: 'Query', getPaymentsOfProduction: Array<{ __typename?: 'Payment', id?: number | null, name: string, link?: string | null, productionId: number, description: string } | null> };

export type GetAllPaymentsQueryVariables = Exact<{
  input: GetPaymentsInput;
}>;


export type GetAllPaymentsQuery = { __typename?: 'Query', getAllPayments: Array<{ __typename?: 'Payment', id?: number | null, name: string, link?: string | null, productionId: number, description: string } | null> };

export type GetAllPricesQueryVariables = Exact<{
  input: GetAllPricesInput;
}>;


export type GetAllPricesQuery = { __typename?: 'Query', getAllPrices: Array<{ __typename?: 'Price', id?: number | null, stageId: number, seatType: number, guestType: number, price: number } | null> };

export type GetAllProductionsQueryVariables = Exact<{
  input?: InputMaybe<GetAllInput>;
}>;


export type GetAllProductionsQuery = { __typename?: 'Query', getAllProductions?: Array<{ __typename?: 'Production', id: number, name: string, description?: string | null, startDate: number, endDate: number, theaterCompanyId?: number | null, url: string, deleted?: boolean | null } | null> | null };

export type CreateSpreadSheetQueryVariables = Exact<{
  stageId: Scalars['Int']['input'];
}>;


export type CreateSpreadSheetQuery = { __typename?: 'Query', createSpreadSheet: { __typename?: 'Response', ok: boolean, message?: string | null, object?: string | null } };

export type CheckAuthTokenQueryVariables = Exact<{
  input: CheckAuthTokenInput;
}>;


export type CheckAuthTokenQuery = { __typename?: 'Query', checkAuthToken: boolean };

export type GetCancelledReservationsQueryVariables = Exact<{
  stageIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetCancelledReservationsQuery = { __typename?: 'Query', getCancelledReservations: { __typename?: 'CancelledReservationsData', stages: Array<{ __typename?: 'Stage', id: number, productionId: number, stageName: string, openDateTime: number, startDateTime: number, endDateTime: number, reservationStart: number, reservationLimit: number, caution: string, disableSeatSelect?: boolean | null, capacity: number } | null>, reservations: Array<{ __typename?: 'Reservation', id?: number | null, lineId?: string | null, name: string, phonetic: string, email: string, note?: string | null, stageId: number, usePoint: number, invitationId?: number | null, confirmed?: boolean | null, payment?: number | null, paymentDeadline?: number | null, cancelled?: boolean | null, confirmationTime?: number | null, paymentTime?: number | null, cancellationTime?: number | null } | null>, guests: Array<{ __typename?: 'Guest', id?: number | null, reservationId: number, seatId: number, guestType: number } | null>, seats: Array<{ __typename?: 'Seat', id?: number | null, stageId: number, seatName: string, row: number, column: number, type: number, reservationId?: number | null, state?: number | null, pairGuestId?: number | null } | null>, seatTypes: Array<{ __typename?: 'SeatType', id: number, stageId: number, name: string, description: string } | null>, guestTypes: Array<{ __typename?: 'GuestType', id: number, stageId: number, name: string } | null>, productions: Array<{ __typename?: 'Production', id: number, name: string, description?: string | null, startDate: number, endDate: number, url: string, location: string, locationLink?: string | null, theaterCompanyName?: string | null, theaterCompanyId?: number | null, deleted?: boolean | null } | null>, payments: Array<{ __typename?: 'Payment', id?: number | null, name: string, link?: string | null, productionId: number, description: string } | null>, prices: Array<{ __typename?: 'Price', id?: number | null, stageId: number, seatType: number, guestType: number, price: number } | null> } };

export type GetReservationWithoutSeatQueryVariables = Exact<{
  input: GetReservationWithoutSeatInput;
}>;


export type GetReservationWithoutSeatQuery = { __typename?: 'Query', getReservationWithoutSeat?: { __typename?: 'Reservation', id?: number | null, lineId?: string | null, name: string, phonetic: string, email: string, note?: string | null, stageId: number, usePoint: number, invitationId?: number | null, confirmed?: boolean | null, payment?: number | null, paymentDeadline?: number | null, cancelled?: boolean | null, confirmationTime?: number | null, paymentTime?: number | null, cancellationTime?: number | null } | null };

export type GetLineProfile2QueryVariables = Exact<{
  input: GetLineProfileInput;
}>;


export type GetLineProfile2Query = { __typename?: 'Query', getLINEProfile2?: { __typename?: 'User', id?: number | null, lineId: string, lineName: string, profilePictureUrl: string, admin: boolean, owner: boolean, point: number } | null };

export type GetOwnTheaterCompaniesQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetOwnTheaterCompaniesQuery = { __typename?: 'Query', getOwnTheaterCompanies: Array<{ __typename?: 'TheaterCompany', id: number, name: string, description?: string | null, url?: string | null } | null> };

export type GetMasterUserQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetMasterUserQuery = { __typename?: 'Query', getMasterUser?: { __typename?: 'MasterUser', id: number, name: string, email: string, master: boolean } | null };

export type GetMasterInitialItemsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetMasterInitialItemsQuery = { __typename?: 'Query', getMasterInitialItems: { __typename?: 'MasterInitialItems', theaterCompanies: Array<{ __typename?: 'TheaterCompany', id: number, name: string, description?: string | null, url?: string | null } | null>, productions: Array<{ __typename?: 'Production', id: number, name: string, description?: string | null, startDate: number, endDate: number, url: string, location: string, location_url: string, location_description: string, theaterCompanyId?: number | null } | null>, stages: Array<{ __typename?: 'Stage', id: number, productionId: number, stageName: string, openDateTime: number, startDateTime: number, endDateTime: number, reservationStart: number, reservationLimit: number, caution: string, mailMessage?: string | null, disableSeatSelect?: boolean | null, capacity: number } | null> } };

export type GetAllSeatsOfStageQueryVariables = Exact<{
  stageId: Scalars['Int']['input'];
}>;


export type GetAllSeatsOfStageQuery = { __typename?: 'Query', getAllSeatsOfStage: Array<{ __typename?: 'Seat', id?: number | null, stageId: number, seatName: string, row: number, column: number, type: number, reservationId?: number | null, locked?: boolean | null } | null> };

export type GetSeatsSettingsOfStageQueryVariables = Exact<{
  stageId: Scalars['Int']['input'];
}>;


export type GetSeatsSettingsOfStageQuery = { __typename?: 'Query', getSeatsSettingsOfStage: { __typename?: 'SeatSettings', seats: Array<{ __typename?: 'Seat', id?: number | null, stageId: number, seatName: string, row: number, column: number, type: number, reservationId?: number | null, locked?: boolean | null } | null>, seatTypes: Array<{ __typename?: 'SeatType', id: number, stageId: number, name: string, description: string } | null>, guestTypes: Array<{ __typename?: 'GuestType', id: number, name: string, stageId: number } | null>, prices: Array<{ __typename?: 'Price', id?: number | null, stageId: number, seatType: number, guestType: number, price: number } | null>, guests: Array<{ __typename?: 'Guest', id?: number | null, reservationId: number, seatId: number, guestType: number, selfReserved?: boolean | null } | null>, reservations: Array<{ __typename?: 'Reservation', id?: number | null, name: string, phonetic: string, email: string, note?: string | null, stageId: number, usePoint: number, invitationId?: number | null, confirmed?: boolean | null, payment?: number | null, paymentDeadline?: number | null, confirmationTime?: number | null, paymentTime?: number | null } | null>, staffs: Array<{ __typename?: 'Staff', id?: number | null, name: string, phonetic: string, productionId: number, stageId?: number | null } | null> } };

export type GetReservationInitialDataQueryVariables = Exact<{
  stageId: Scalars['Int']['input'];
}>;


export type GetReservationInitialDataQuery = { __typename?: 'Query', getReservationInitialData: { __typename?: 'ReservationInitialData', remainingSeats: number, productionName?: string | null, seats: Array<{ __typename?: 'Seat', id?: number | null, stageId: number, seatName: string, row: number, column: number, type: number, reservationId?: number | null, locked?: boolean | null } | null>, seatTypes: Array<{ __typename?: 'SeatType', id: number, stageId: number, name: string, description: string } | null>, guestTypes: Array<{ __typename?: 'GuestType', id: number, name: string, stageId: number } | null>, prices: Array<{ __typename?: 'Price', id?: number | null, stageId: number, seatType: number, guestType: number, price: number } | null>, staffs: Array<{ __typename?: 'Staff', id?: number | null, name: string, phonetic: string, productionId: number, stageId?: number | null } | null>, payments: Array<{ __typename?: 'Payment', id?: number | null, name: string, link?: string | null, productionId: number, description: string } | null>, stage?: { __typename?: 'Stage', id: number, productionId: number, stageName: string, openDateTime: number, startDateTime: number, endDateTime: number, reservationStart: number, reservationLimit: number, caution: string, disableSeatSelect?: boolean | null } | null } };

export type GetCancelManagementItemsQueryVariables = Exact<{
  stageId: Scalars['Int']['input'];
}>;


export type GetCancelManagementItemsQuery = { __typename?: 'Query', getCancelManagementItems: { __typename?: 'CancelManagementItems', reservations: Array<{ __typename?: 'Reservation', id?: number | null, lineId?: string | null, name: string, phonetic: string, email: string, note?: string | null, stageId: number, usePoint: number, invitationId?: number | null, confirmed?: boolean | null, payment?: number | null, paymentDeadline?: number | null, cancelled?: boolean | null, confirmationTime?: number | null, paymentTime?: number | null, cancellationTime?: number | null } | null>, guests: Array<{ __typename?: 'Guest', id?: number | null, reservationId: number, seatId: number, guestType: number } | null>, seats: Array<{ __typename?: 'Seat', id?: number | null, stageId: number, seatName: string, row: number, column: number, type: number, reservationId?: number | null, state?: number | null, pairGuestId?: number | null } | null>, seatTypes: Array<{ __typename?: 'SeatType', id: number, stageId: number, name: string, description: string } | null>, guestTypes: Array<{ __typename?: 'GuestType', id: number, stageId: number, name: string } | null>, payments: Array<{ __typename?: 'Payment', id?: number | null, name: string, link?: string | null, productionId: number, description: string } | null>, prices: Array<{ __typename?: 'Price', id?: number | null, stageId: number, seatType: number, guestType: number, price: number } | null> } };

export type GetReservationsByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetReservationsByEmailQuery = { __typename?: 'Query', getReservationsByEmail: { __typename?: 'ReservationDataForUpdate', reservations: Array<{ __typename?: 'Reservation', id?: number | null, lineId?: string | null, name: string, phonetic: string, email: string, note?: string | null, stageId: number, usePoint: number, invitationId?: number | null, confirmed?: boolean | null, payment?: number | null, paymentDeadline?: number | null, cancelled?: boolean | null, confirmationTime?: number | null, paymentTime?: number | null, cancellationTime?: number | null } | null>, guests: Array<{ __typename?: 'Guest', id?: number | null, reservationId: number, seatId: number, guestType: number } | null>, seats: Array<{ __typename?: 'Seat', id?: number | null, stageId: number, seatName: string, row: number, column: number, type: number, reservationId?: number | null, state?: number | null, pairGuestId?: number | null } | null>, seatTypes: Array<{ __typename?: 'SeatType', id: number, stageId: number, name: string, description: string } | null>, guestTypes: Array<{ __typename?: 'GuestType', id: number, stageId: number, name: string } | null>, payments: Array<{ __typename?: 'Payment', id?: number | null, name: string, link?: string | null, productionId: number, description: string } | null>, prices: Array<{ __typename?: 'Price', id?: number | null, stageId: number, seatType: number, guestType: number, price: number } | null>, staffs: Array<{ __typename?: 'Staff', id?: number | null, name: string, phonetic: string, productionId: number } | null>, productions: Array<{ __typename?: 'Production', id: number, name: string, description?: string | null, startDate: number, endDate: number, url: string, location: string, location_url: string, location_description: string, theaterCompanyId?: number | null } | null>, stages: Array<{ __typename?: 'Stage', id: number, productionId: number, stageName: string, openDateTime: number, startDateTime: number, endDateTime: number, reservationStart: number, reservationLimit: number, caution: string, disableSeatSelect?: boolean | null, capacity: number } | null> } };

export type GetConfirmManagementItemsQueryVariables = Exact<{
  stageId: Scalars['Int']['input'];
}>;


export type GetConfirmManagementItemsQuery = { __typename?: 'Query', getConfirmManagementItems: { __typename?: 'ConfirmManagementItems', reservations: Array<{ __typename?: 'Reservation', id?: number | null, lineId?: string | null, name: string, phonetic: string, email: string, note?: string | null, stageId: number, usePoint: number, invitationId?: number | null, confirmed?: boolean | null, payment?: number | null, paymentDeadline?: number | null, cancelled?: boolean | null, confirmationTime?: number | null, paymentTime?: number | null, cancellationTime?: number | null } | null>, guests: Array<{ __typename?: 'Guest', id?: number | null, reservationId: number, seatId: number, guestType: number } | null>, seats: Array<{ __typename?: 'Seat', id?: number | null, stageId: number, seatName: string, row: number, column: number, type: number, reservationId?: number | null, state?: number | null, pairGuestId?: number | null } | null>, seatTypes: Array<{ __typename?: 'SeatType', id: number, stageId: number, name: string, description: string } | null>, guestTypes: Array<{ __typename?: 'GuestType', id: number, stageId: number, name: string } | null>, payments: Array<{ __typename?: 'Payment', id?: number | null, name: string, link?: string | null, productionId: number, description: string } | null>, prices: Array<{ __typename?: 'Price', id?: number | null, stageId: number, seatType: number, guestType: number, price: number } | null> } };

export type CheckConfirmTokenQueryVariables = Exact<{
  input: CheckConfirmTokenInput;
}>;


export type CheckConfirmTokenQuery = { __typename?: 'Query', checkConfirmToken: { __typename?: 'Response', ok: boolean } };


export const CreateSeats = gql`
    mutation createSeats($input: [[CreateSeatsInput!]!]!) {
  createSeats(input: $input)
}
    `;
export const CopySeats = gql`
    mutation copySeats($input: CopySeatsInput!) {
  copySeats(input: $input)
}
    `;
export const CreateStage = gql`
    mutation createStage($input: CreateStageInput!) {
  createStage(input: $input) {
    id
    productionId
    stageName
    openDateTime
    startDateTime
    endDateTime
    reservationStart
    reservationLimit
    caution
    mailMessage
    disableSeatSelect
  }
}
    `;
export const CreateSeatType = gql`
    mutation createSeatType($input: CreateSeatTypeInput!) {
  createSeatType(input: $input) {
    id
    stageId
    name
    description
  }
}
    `;
export const DeleteSeatType = gql`
    mutation deleteSeatType($id: Int!) {
  deleteSeatType(id: $id) {
    id
    stageId
    name
    description
  }
}
    `;
export const CreateGuestType = gql`
    mutation createGuestType($input: CreateGuestTypeInput!) {
  createGuestType(input: $input) {
    id
    stageId
    name
  }
}
    `;
export const DeleteGuestType = gql`
    mutation deleteGuestType($id: Int!) {
  deleteGuestType(id: $id) {
    id
    stageId
    name
  }
}
    `;
export const CreateReservation = gql`
    mutation createReservation($input: CreateReservationInput!) {
  createReservation(input: $input) {
    id
    lineId
    name
    phonetic
    email
    note
    stageId
    usePoint
    invitationId
  }
}
    `;
export const SetPriceList = gql`
    mutation setPriceList($input: SetPriceListInput!) {
  setPriceList(input: $input)
}
    `;
export const SetStaffsOfProduction = gql`
    mutation setStaffsOfProduction($input: SetStaffsInput!) {
  setStaffsOfProduction(input: $input)
}
    `;
export const SetStaffsOfStage = gql`
    mutation setStaffsOfStage($input: SetStaffsInput!) {
  setStaffsOfStage(input: $input)
}
    `;
export const SubmitReservation = gql`
    mutation submitReservation($input: SubmitReservationInput!) {
  submitReservation(input: $input) {
    ok
    message
  }
}
    `;
export const UpdateStage = gql`
    mutation updateStage($input: UpdateStageInput!) {
  updateStage(input: $input)
}
    `;
export const CreateAuthToken = gql`
    mutation createAuthToken($stageId: Int!) {
  createAuthToken(stageId: $stageId)
}
    `;
export const AssignSeats = gql`
    mutation assignSeats($input: AssignSeatsInput!) {
  assignSeats(input: $input)
}
    `;
export const UpdateReservation = gql`
    mutation updateReservation($input: UpdateReservationInput!) {
  updateReservation(input: $input) {
    ok
    message
  }
}
    `;
export const TempReservation = gql`
    mutation tempReservation($input: TempReservationInput!) {
  tempReservation(input: $input) {
    ok
    message
  }
}
    `;
export const UpdatePayments = gql`
    mutation updatePayments($input: UpdatePaymentsInput!) {
  updatePayments(input: $input) {
    ok
    message
  }
}
    `;
export const GetOrRegisterUser = gql`
    mutation getOrRegisterUser($input: getOrRegisterUserInput!) {
  getOrRegisterUser(input: $input) {
    id
    idToken
    line_id
    line_name
    line_picture
    admin
    owner
    deleted
  }
}
    `;
export const CreateVipReservation = gql`
    mutation createVipReservation($input: CreateVipReservationInput!) {
  createVipReservation(input: $input) {
    ok
    message
    object
  }
}
    `;
export const SendEmailToStageGuests = gql`
    mutation sendEmailToStageGuests($input: SendEmailToStageGuestsInput!) {
  sendEmailToStageGuests(input: $input) {
    ok
    message
    object
  }
}
    `;
export const CreateTheaterCompany = gql`
    mutation createTheaterCompany($input: CreateTheaterCompanyInput!) {
  createTheaterCompany(input: $input) {
    ok
    message
    object
  }
}
    `;
export const UpdateProduction = gql`
    mutation updateProduction($input: UpdateProductionInput!) {
  updateProduction(input: $input) {
    ok
    message
    object
  }
}
    `;
export const UpdatePayment = gql`
    mutation updatePayment($input: UpdatedPaymentInput!) {
  updatePayment(input: $input) {
    ok
    message
  }
}
    `;
export const UpdateTheaterCompany = gql`
    mutation updateTheaterCompany($input: UpdateTheaterCompanyInput!) {
  updateTheaterCompany(input: $input) {
    ok
    message
    object
  }
}
    `;
export const CreateProduction = gql`
    mutation createProduction($input: CreateProductionInput!) {
  createProduction(input: $input) {
    ok
    message
    object
  }
}
    `;
export const CreateMasterUser = gql`
    mutation createMasterUser($input: CreateMasterUserInput!) {
  createMasterUser(input: $input) {
    id
    name
    email
    master
  }
}
    `;
export const UpdateSeats = gql`
    mutation updateSeats($input: UpdateSeatsInput2!) {
  updateSeats(input: $input) {
    ok
    message
    object
  }
}
    `;
export const ConfirmReservation = gql`
    mutation confirmReservation($input: ConfirmReservationInput!) {
  confirmReservation(input: $input) {
    ok
    message
    object
  }
}
    `;
export const CreateSeatsFromCsv = gql`
    mutation createSeatsFromCsv($input: CreateSeatsFromCsvInput!) {
  createSeatsFromCsv(input: $input) {
    ok
    message
  }
}
    `;
export const SendConfirmEmail = gql`
    mutation sendConfirmEmail($email: String!) {
  sendConfirmEmail(email: $email) {
    ok
  }
}
    `;
export const GetAllStages = gql`
    query getAllStages($productionId: Int) {
  getAllStages(productionId: $productionId) {
    id
    productionId
    stageName
    openDateTime
    startDateTime
    endDateTime
    reservationStart
    reservationLimit
    caution
    mailMessage
    disableSeatSelect
  }
}
    `;
export const GetSeatsOfStage = gql`
    query getSeatsOfStage($stageId: Int!) {
  getSeatsOfStage(stageId: $stageId) {
    id
    stageId
    seatName
    row
    column
    type
    state
    tempLineId
    tempMail
  }
}
    `;
export const GetOneAheadUserInfo = gql`
    query getOneAheadUserInfo($idToken: String!) {
  getOneAheadUserInfo(idToken: $idToken) {
    lineId
    lineName
    profilePictureUrl
    admin
    owner
    point
  }
}
    `;
export const GetOneAheadProductionsInfo = gql`
    query getOneAheadProductionsInfo($lineId: String!) {
  getOneAheadProductionsInfo(lineId: $lineId) {
    id
    name
    description
    startDate
    endDate
    url
    location
    locationLink
    theaterCompanyName
  }
}
    `;
export const GetOneAheadProductionInfo = gql`
    query getOneAheadProductionInfo($productionId: Int!) {
  getOneAheadProductionInfo(productionId: $productionId) {
    id
    name
    description
    startDate
    endDate
    url
    location
    locationLink
    theaterCompanyName
  }
}
    `;
export const GetSeatTypes = gql`
    query getSeatTypes($stageId: Int!) {
  getSeatTypes(stageId: $stageId) {
    id
    stageId
    name
    description
  }
}
    `;
export const GetGuestTypes = gql`
    query getGuestTypes($stageId: Int!) {
  getGuestTypes(stageId: $stageId) {
    id
    name
    stageId
  }
}
    `;
export const GetStaffsOfProduction = gql`
    query getStaffsOfProduction($productionId: Int!) {
  getStaffsOfProduction(productionId: $productionId) {
    id
    name
    phonetic
    stageId
    productionId
  }
}
    `;
export const GetStaffsOfStage = gql`
    query getStaffsOfStage($stageId: Int!) {
  getStaffsOfStage(stageId: $stageId) {
    id
    name
    phonetic
    stageId
    productionId
  }
}
    `;
export const GetPriceList = gql`
    query getPriceList($stageId: Int!) {
  getPriceList(stageId: $stageId) {
    id
    stageId
    seatType
    guestType
    price
  }
}
    `;
export const GetGuestsOfStage = gql`
    query getGuestsOfStage($stageId: Int!) {
  getGuestsOfStage(stageId: $stageId) {
    id
    reservationId
    seatId
    guestType
    selfReserved
  }
}
    `;
export const GetReservationsOfStage = gql`
    query getReservationsOfStage($stageId: Int!) {
  getReservationsOfStage(stageId: $stageId) {
    id
    lineId
    name
    phonetic
    email
    note
    stageId
    usePoint
    invitationId
    confirmed
    payment
    paymentDeadline
    cancelled
    confirmationTime
    paymentTime
    cancellationTime
  }
}
    `;
export const GetRemainingSeats = gql`
    query getRemainingSeats($stageId: Int!) {
  getRemainingSeats(stageId: $stageId)
}
    `;
export const GetReservationByLineId = gql`
    query getReservationByLineId($lineId: String!) {
  getReservationByLineId(lineId: $lineId) {
    stages {
      id
      productionId
      stageName
      openDateTime
      startDateTime
      endDateTime
      reservationStart
      reservationLimit
      caution
      disableSeatSelect
      capacity
    }
    reservations {
      id
      lineId
      name
      phonetic
      email
      note
      stageId
      usePoint
      invitationId
      payment
    }
    guests {
      id
      reservationId
      seatId
      guestType
    }
    staffs {
      id
      name
      phonetic
      productionId
      stageId
    }
    seats {
      id
      stageId
      seatName
      row
      column
      type
      reservationId
      state
      pairGuestId
    }
    seatTypes {
      id
      stageId
      name
      description
    }
    guestTypes {
      id
      stageId
      name
    }
    productions {
      id
      name
      description
      startDate
      endDate
      url
      location
      locationLink
      theaterCompanyName
      theaterCompanyId
      deleted
    }
    payments {
      id
      name
      link
      productionId
      description
    }
    prices {
      id
      stageId
      seatType
      guestType
      price
    }
  }
}
    `;
export const GetPaymentsOfProduction = gql`
    query getPaymentsOfProduction($productionId: Int!) {
  getPaymentsOfProduction(productionId: $productionId) {
    id
    name
    link
    productionId
    description
  }
}
    `;
export const GetAllPayments = gql`
    query getAllPayments($input: GetPaymentsInput!) {
  getAllPayments(input: $input) {
    id
    name
    link
    productionId
    description
  }
}
    `;
export const GetAllPrices = gql`
    query getAllPrices($input: GetAllPricesInput!) {
  getAllPrices(input: $input) {
    id
    stageId
    seatType
    guestType
    price
  }
}
    `;
export const GetAllProductions = gql`
    query getAllProductions($input: getAllInput) {
  getAllProductions(input: $input) {
    id
    name
    description
    startDate
    endDate
    theaterCompanyId
    url
    deleted
  }
}
    `;
export const CreateSpreadSheet = gql`
    query createSpreadSheet($stageId: Int!) {
  createSpreadSheet(stageId: $stageId) {
    ok
    message
    object
  }
}
    `;
export const CheckAuthToken = gql`
    query checkAuthToken($input: CheckAuthTokenInput!) {
  checkAuthToken(input: $input)
}
    `;
export const GetCancelledReservations = gql`
    query getCancelledReservations($stageIds: [Int!]!) {
  getCancelledReservations(stageIds: $stageIds) {
    stages {
      id
      productionId
      stageName
      openDateTime
      startDateTime
      endDateTime
      reservationStart
      reservationLimit
      caution
      disableSeatSelect
      capacity
    }
    reservations {
      id
      lineId
      name
      phonetic
      email
      note
      stageId
      usePoint
      invitationId
      confirmed
      payment
      paymentDeadline
      cancelled
      confirmationTime
      paymentTime
      cancellationTime
    }
    guests {
      id
      reservationId
      seatId
      guestType
    }
    seats {
      id
      stageId
      seatName
      row
      column
      type
      reservationId
      state
      pairGuestId
    }
    seatTypes {
      id
      stageId
      name
      description
    }
    guestTypes {
      id
      stageId
      name
    }
    productions {
      id
      name
      description
      startDate
      endDate
      url
      location
      locationLink
      theaterCompanyName
      theaterCompanyId
      deleted
    }
    payments {
      id
      name
      link
      productionId
      description
    }
    prices {
      id
      stageId
      seatType
      guestType
      price
    }
  }
}
    `;
export const GetReservationWithoutSeat = gql`
    query getReservationWithoutSeat($input: GetReservationWithoutSeatInput!) {
  getReservationWithoutSeat(input: $input) {
    id
    lineId
    name
    phonetic
    email
    note
    stageId
    usePoint
    invitationId
    confirmed
    payment
    paymentDeadline
    cancelled
    confirmationTime
    paymentTime
    cancellationTime
  }
}
    `;
export const GetLineProfile2 = gql`
    query getLINEProfile2($input: getLINEProfileInput!) {
  getLINEProfile2(input: $input) {
    id
    lineId
    lineName
    profilePictureUrl
    admin
    owner
    point
  }
}
    `;
export const GetOwnTheaterCompanies = gql`
    query getOwnTheaterCompanies($email: String!) {
  getOwnTheaterCompanies(email: $email) {
    id
    name
    description
    url
  }
}
    `;
export const GetMasterUser = gql`
    query getMasterUser($email: String!) {
  getMasterUser(email: $email) {
    id
    name
    email
    master
  }
}
    `;
export const GetMasterInitialItems = gql`
    query getMasterInitialItems($userId: Int!) {
  getMasterInitialItems(userId: $userId) {
    theaterCompanies {
      id
      name
      description
      url
    }
    productions {
      id
      name
      description
      startDate
      endDate
      url
      location
      location_url
      location_description
      theaterCompanyId
    }
    stages {
      id
      productionId
      stageName
      openDateTime
      startDateTime
      endDateTime
      reservationStart
      reservationLimit
      caution
      mailMessage
      disableSeatSelect
      capacity
    }
  }
}
    `;
export const GetAllSeatsOfStage = gql`
    query getAllSeatsOfStage($stageId: Int!) {
  getAllSeatsOfStage(stageId: $stageId) {
    id
    stageId
    seatName
    row
    column
    type
    reservationId
    locked
  }
}
    `;
export const GetSeatsSettingsOfStage = gql`
    query getSeatsSettingsOfStage($stageId: Int!) {
  getSeatsSettingsOfStage(stageId: $stageId) {
    seats {
      id
      stageId
      seatName
      row
      column
      type
      reservationId
      locked
    }
    seatTypes {
      id
      stageId
      name
      description
    }
    guestTypes {
      id
      name
      stageId
    }
    prices {
      id
      stageId
      seatType
      guestType
      price
    }
    guests {
      id
      reservationId
      seatId
      guestType
      selfReserved
    }
    reservations {
      id
      name
      phonetic
      email
      note
      stageId
      usePoint
      invitationId
      confirmed
      payment
      paymentDeadline
      confirmationTime
      paymentTime
    }
    staffs {
      id
      name
      phonetic
      productionId
      stageId
    }
  }
}
    `;
export const GetReservationInitialData = gql`
    query getReservationInitialData($stageId: Int!) {
  getReservationInitialData(stageId: $stageId) {
    remainingSeats
    productionName
    seats {
      id
      stageId
      seatName
      row
      column
      type
      reservationId
      locked
    }
    seatTypes {
      id
      stageId
      name
      description
    }
    guestTypes {
      id
      name
      stageId
    }
    prices {
      id
      stageId
      seatType
      guestType
      price
    }
    staffs {
      id
      name
      phonetic
      productionId
      stageId
    }
    payments {
      id
      name
      link
      productionId
      description
    }
    stage {
      id
      productionId
      stageName
      openDateTime
      startDateTime
      endDateTime
      reservationStart
      reservationLimit
      caution
      disableSeatSelect
    }
  }
}
    `;
export const GetCancelManagementItems = gql`
    query getCancelManagementItems($stageId: Int!) {
  getCancelManagementItems(stageId: $stageId) {
    reservations {
      id
      lineId
      name
      phonetic
      email
      note
      stageId
      usePoint
      invitationId
      confirmed
      payment
      paymentDeadline
      cancelled
      confirmationTime
      paymentTime
      cancellationTime
    }
    guests {
      id
      reservationId
      seatId
      guestType
    }
    seats {
      id
      stageId
      seatName
      row
      column
      type
      reservationId
      state
      pairGuestId
    }
    seatTypes {
      id
      stageId
      name
      description
    }
    guestTypes {
      id
      stageId
      name
    }
    payments {
      id
      name
      link
      productionId
      description
    }
    prices {
      id
      stageId
      seatType
      guestType
      price
    }
  }
}
    `;
export const GetReservationsByEmail = gql`
    query getReservationsByEmail($email: String!) {
  getReservationsByEmail(email: $email) {
    reservations {
      id
      lineId
      name
      phonetic
      email
      note
      stageId
      usePoint
      invitationId
      confirmed
      payment
      paymentDeadline
      cancelled
      confirmationTime
      paymentTime
      cancellationTime
    }
    guests {
      id
      reservationId
      seatId
      guestType
    }
    seats {
      id
      stageId
      seatName
      row
      column
      type
      reservationId
      state
      pairGuestId
    }
    seatTypes {
      id
      stageId
      name
      description
    }
    guestTypes {
      id
      stageId
      name
    }
    payments {
      id
      name
      link
      productionId
      description
    }
    prices {
      id
      stageId
      seatType
      guestType
      price
    }
    staffs {
      id
      name
      phonetic
      productionId
    }
    productions {
      id
      name
      description
      startDate
      endDate
      url
      location
      location_url
      location_description
      theaterCompanyId
    }
    stages {
      id
      productionId
      stageName
      openDateTime
      startDateTime
      endDateTime
      reservationStart
      reservationLimit
      caution
      disableSeatSelect
      capacity
    }
  }
}
    `;
export const GetConfirmManagementItems = gql`
    query getConfirmManagementItems($stageId: Int!) {
  getConfirmManagementItems(stageId: $stageId) {
    reservations {
      id
      lineId
      name
      phonetic
      email
      note
      stageId
      usePoint
      invitationId
      confirmed
      payment
      paymentDeadline
      cancelled
      confirmationTime
      paymentTime
      cancellationTime
    }
    guests {
      id
      reservationId
      seatId
      guestType
    }
    seats {
      id
      stageId
      seatName
      row
      column
      type
      reservationId
      state
      pairGuestId
    }
    seatTypes {
      id
      stageId
      name
      description
    }
    guestTypes {
      id
      stageId
      name
    }
    payments {
      id
      name
      link
      productionId
      description
    }
    prices {
      id
      stageId
      seatType
      guestType
      price
    }
  }
}
    `;
export const CheckConfirmToken = gql`
    query checkConfirmToken($input: CheckConfirmTokenInput!) {
  checkConfirmToken(input: $input) {
    ok
  }
}
    `;